import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loader',
});

const state = {
    lastQuery: null,
    tagList: [],
    tag: {
        name: null,
        description: null,
        parent_id: null,
        products: [],
    },
};

const getters = {
    tagList: state => state.tagList,
    tag: state => state.tag,
};

const mutations = {
    [type.SET_TAG_LIST](state, tagList) {
        state.tagList = tagList;
    },

    [type.ADD_TAG](state, tag) {
        state.tagList.push(tag);
    },

    [type.SET_TAG](state, tag) {
        state.tag = tag;
    },

    [type.SET_TAG_ATTRIBUTE](state, { key, value } = {}) {
        state.tag[key] = value;
    },
};

const actions = {
    async getTagList({ commit, dispatch }) {
        startLoading(dispatch, 'fetch-tag-list');

        const route = Laroute.route('data_api.tag_list');
        const { data } = await axios.get(route);

        commit(type.SET_TAG_LIST, data);
        endLoading(dispatch, 'fetch-tag-list');
    },

    async getTag({ commit, dispatch }, id) {
        startLoading(dispatch, 'fetch-tag');
        const route = Laroute.route('settings.tags.show', { id });

        try {
            const { data } = await axios.get(route);
            commit(type.SET_TAG, data);
            endLoading(dispatch, 'fetch-tag');
        } catch (e) {
            endLoading(dispatch, 'fetch-tag');
        }
    },

    addTag({ commit }, tag) {
        commit(type.ADD_TAG, tag);
    },

    setTagAttribute({ commit }, { key, value }) {
        commit(type.SET_TAG_ATTRIBUTE, { key, value });
    },

    async createTag({ commit, state, dispatch }) {
        let url = Laroute.route('settings.tags.create');
        startLoading(dispatch, 'save-tag');

        try {
            await axios.post(url, state.tag);
            endLoading(dispatch, 'save-tag');
        } catch (e) {
            endLoading(dispatch, 'save-tag');
            throw e;
        }
    },

    async updateTag({ commit, state, dispatch }) {
        const id = state.tag.id;
        let url = Laroute.route('settings.tags.update', { id });
        startLoading(dispatch, 'save-tag');

        try {
            await axios.put(
                url,
                _.pick(state.tag, ['name', 'parent_id', 'description']),
            );
            endLoading(dispatch, 'save-tag');
        } catch (e) {
            endLoading(dispatch, 'save-tag');
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/tag.js